module.exports = __webpack_public_path__ + "img/img_userCase3.29fc1b2b.png";